import { render, staticRenderFns } from "./TherapistLetter.vue?vue&type=template&id=7ba84714&"
import script from "./TherapistLetter.vue?vue&type=script&lang=ts&"
export * from "./TherapistLetter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports